import Loader from "@/components/progress/Loader"
import Stepper from "@/components/progress/Stepper"

export default {
    install(Vue) {
        Vue.component(Loader.name, Loader)
        Vue.component(Stepper.name, Stepper)
    },
}
